/* Strength Metrics — sign-up form helpers. Loaded after sm-join.js. */
// Pre-select a plan from the URL, e.g. /pages/join?type=student&term=weekly
// or /pages/join?entry=casual&pass=day (used by the pricing on the gym page).
(function () {
  var p = new URLSearchParams(window.location.search);
  function val(k) { var v = p.get(k); return v && /^[a-z]+$/.test(v) ? v : null; }
  function pick(sel) { return document.querySelector('#sm-join ' + sel); }
  var entry = val('entry'), type = val('type'), term = val('term'), pass = val('pass');
  if (!entry && (type || term)) entry = 'membership';
  if (!entry && pass) entry = 'casual';
  var e = entry && pick('.entry-btn[data-entry="' + entry + '"]');
  if (e) selectEntry(e);
  var t = type && pick('.type-card[data-type="' + type + '"]');
  if (t) selectType(t);
  var r = term && pick('.term-card[data-term="' + term + '"]');
  if (r) selectTerm(r);
  var c = pass && pick('.casual-card[data-casual="' + pass + '"]');
  if (c) selectCasual(c);
})();

function initFakePlaceholders() {
  document.querySelectorAll('.ph-text').forEach(function(span) {
    var input = document.getElementById(span.dataset.for);
    if (!input) return;
    function update() {
      span.classList.toggle('hidden', input.value.length > 0);
    }
    input.addEventListener('input', update);
    input.addEventListener('change', update);
    input.addEventListener('focus', function() { span.classList.add('hidden'); });
    input.addEventListener('blur', update);
    update();
  });
}
initFakePlaceholders();
window.addEventListener('load', initFakePlaceholders);

// The plan, pass and yes/no cards are divs that act as radio buttons. Let the
// keyboard use them: Enter or Space picks the focused card, and the arrow keys
// move within a group, the way native radio buttons work.
(function () {
  var form = document.getElementById('sm-join');
  if (!form) return;
  form.addEventListener('keydown', function (e) {
    var card = e.target.closest('[role="radio"]');
    if (!card) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      card.click();
    } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      var group = card.closest('[role="radiogroup"]');
      if (!group) return;
      var items = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
      var i = items.indexOf(card);
      var next = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : items.length - 1)) % items.length];
      if (next) { e.preventDefault(); next.focus(); next.click(); }
    }
  });
})();
